import { render, staticRenderFns } from "./MealsTableView.vue?vue&type=template&id=cc56426e&scoped=true"
import script from "./MealsTableView.vue?vue&type=script&lang=js"
export * from "./MealsTableView.vue?vue&type=script&lang=js"
import style0 from "./MealsTableView.vue?vue&type=style&index=0&id=cc56426e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc56426e",
  null
  
)

export default component.exports